import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

import programStatuses from 'data/program_statuses';
import programTypeStatuses from 'data/program_type_statuses';

export default function Details({ template }) {
  const programStatus = (value) => (
    programStatuses.find((status) => status.value === value)
  );

  const programTypeStatus = (value) => (
    programTypeStatuses.find((status) => status.value === value)
  );

  const columns = [
    {
      name: 'Member',
      selector: (row) => row.member,
      sortable: true,
    },
    ...(template.attributes.type !== 'cpa' ? [{
      name: 'Coach',
      selector: (row) => row.coach,
      sortable: true,
    }] : []),
    {
      name: 'Status',
      selector: (row) => row.status,
      cell: (row) => programStatus(row.status).label,
      sortable: true,
    },
  ];

  return (
    <>
      <Row>
        <Col md={6}>
          Enterprise:
          <br />
          <strong>{template.attributes.enterprise}</strong>
        </Col>

        <Col md={6}>
          Program Name:
          <br />
          <strong>{template.attributes.title}</strong>
        </Col>
      </Row>

      <Row className="mt30">
        <Col md={6}>
          Program Type:
          <br />
          <strong>{programTypeStatus(template.attributes.type)?.label}</strong>
        </Col>

        <Col md={6}>
          Sessions:
          <br />
          <strong>
            {template.attributes.type === 'cpa' ? 'N/A' : template.attributes.sessions}
          </strong>
        </Col>
      </Row>

      <Row className="mt30 mb40">
        <Col md={4}>
          Assigned:
          <br />
          <strong>{template.attributes.statistics.assigned}</strong>
        </Col>

        <Col md={4}>
          In Progress:
          <br />
          <strong>{template.attributes.statistics.in_progress}</strong>
        </Col>

        <Col md={4}>
          Completed:
          <br />
          <strong>{template.attributes.statistics.completed}</strong>
        </Col>
      </Row>

      <DataTable
        columns={columns}
        data={template.attributes.programs}
        className="datatable-style"
        noHeader
        pagination
      />
    </>
  );
}

Details.propTypes = {
  template: PropTypes.object.isRequired,
};
